"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectButton = void 0;
const react_1 = __importStar(require("react"));
const ArrowIcon_1 = require("../../ArrowIcon");
const public_1 = require("../../common/public");
const ControlTextWithTooltip_1 = require("./helpers/ControlTextWithTooltip");
const SelectButton_styles_1 = require("./SelectButton.styles");
const helpers_1 = require("../../helpers");
const Icon_1 = require("../../Icon");
const StackView_1 = require("../../StackView");
exports.SelectButton = (0, helpers_1.createUIElement)('SelectButton', (_a, ref) => {
    var { className, disabled, placeholder = 'Not chosen...', active, size, error, children, text, onKeyDownActivate, iconBefore, iconAfter = react_1.default.createElement(ArrowIcon_1.ArrowIcon, { direction: public_1.ARROW_DIRECTION.down }), onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, hasLinkStyles, hasTruncate = true, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "disabled", "placeholder", "active", "size", "error", "children", "text", "onKeyDownActivate", "iconBefore", "iconAfter", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", "hasLinkStyles", "hasTruncate", 'data-selector-id']);
    const controlText = text || children || placeholder || '';
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'selectbutton', [initialDataSelectorId]);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        if (e.keyCode === helpers_1.KeyCode.Space || e.keyCode === helpers_1.KeyCode.Enter) {
            onKeyDownActivate === null || onKeyDownActivate === void 0 ? void 0 : onKeyDownActivate();
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    }, [onKeyDown, onKeyDownActivate]);
    const buttonSize = (0, react_1.useMemo)(() => size || public_1.CONTROL_SIZE.full, [size]);
    const handleOnClick = (0, react_1.useCallback)((e) => {
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    }, [disabled, onClick]);
    const handleOnMouseDown = (0, react_1.useCallback)((e) => {
        if (!disabled) {
            onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
        }
    }, [disabled, onMouseDown]);
    const handleOnMouseUp = (0, react_1.useCallback)((e) => {
        if (!disabled) {
            onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp(e);
        }
    }, [disabled, onMouseUp]);
    return (react_1.default.createElement(SelectButton_styles_1.StyledSelectButton, Object.assign({}, rest, { ref: ref, hasTruncate: hasTruncate, style: style, "data-selector-id": dataSelectorId, active: active, isDisabled: disabled, error: error, size: buttonSize, onFocus: onFocus, onBlur: onBlur, onClick: handleOnClick, onMouseDown: handleOnMouseDown, onMouseUp: handleOnMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasLinkStyles: hasLinkStyles, onKeyDown: handleKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, type: "button", "aria-disabled": disabled, className: (0, helpers_1.cn)('vm-SelectButton', className) }),
        react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.start },
            iconBefore && react_1.default.createElement(Icon_1.Icon, { src: iconBefore, error: error, disabled: disabled }),
            controlText && (react_1.default.createElement(ControlTextWithTooltip_1.ControlTextWithTooltip, { disabled: disabled, error: error, hasTruncate: hasTruncate, controlText: text || children || placeholder })),
            iconAfter && react_1.default.createElement(Icon_1.Icon, { src: iconAfter, error: error, disabled: disabled }))));
});
//# sourceMappingURL=SelectButton.js.map